import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { aliasesConfig } from "./aliases.const";
import { buttonsInfoConfig } from "./buttonsInfo-config.const";

import { LzPurchaseService } from "../../../lz-purchase/services/lz-purchase.service";
import { CustomRequestService } from "../../../../services/custom-request/custom-request.service";
import { LzUserServiceV2 } from "../../../lz-user/services/lz-user.serivce.v2";
import { LzProductConfig } from '../../../../services/product-config/poduct-config';

@Component({
  selector: 'access-message',
  template: `<div class="container" *ngIf="isShowing">
  <div class="row">
    <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12 info-block">
      <div class="header-access">
        <div *ngIf="aliasInfo && aliasInfo.module" id="{{aliasInfo.module}}" class="button {{aliasInfo.module}}">
          <div class="box">
            <div class="module_ico {{buttonsInfo[aliasInfo.module].ico}}"></div>
            <div class="title">{{buttonsInfo[aliasInfo.module].name[lang]}}</div>
            <div class="type" *ngIf="buttonsInfo[aliasInfo.module].type">{{buttonsInfo[aliasInfo.module].type[lang]}}</div>
          </div>
        </div>
        <div class="title" *ngIf="aliasInfo && aliasInfo.module">
          <span>{{buttonsInfo[aliasInfo.module].name[lang]}}</span>
          <span *ngIf="buttonsInfo[aliasInfo.module].type">{{buttonsInfo[aliasInfo.module].type[lang]}}</span>
        </div>
      </div>
      <div class="about-module" *ngIf="doc && doc.text" [innerHTML]="doc.text"></div>
    </div>

    <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 buttons-block" *ngIf="isAnonymous">
      <div *ngIf="!isFreeInIdLevel" class="title">{{'access.titleBuyForm' | translate}}</div>
      <div *ngIf="isFreeInIdLevel" class="title pb25">{{'access.titleAuthForm' | translate}}</div>
      <div class="btn-access-block">
        <div class="row">
          <a *ngIf="!isFreeInIdLevel" class="access-btn" target="_blank" href="https://platforma.ligazakon.net/buy-{{lang}}/"><span
              class="btn-primary-text">{{'access.btnBuy' | translate}}</span></a>
          <a *ngIf="isFreeInIdLevel" class="access-btn" (click)="goReg()">{{'access.reg' | translate}}</a>
        </div>
        <div class="row">
          <a *ngIf="!isFreeInIdLevel && productId != 'reporting' && productId != 'semantrum_web'" class="hint cp"
            (click)="doPurchase(productCode, true); close()">{{'access.btnTry' | translate}}</a>
          <div *ngIf="isFreeInIdLevel" class="sub-auth-title">{{'access.subtitleAuthForm' | translate}}</div>
          <a *ngIf="isFreeInIdLevel && !productBuyLink && productId != 'personalExpert'" class="hint cp" (click)="goAuth()">{{'access.auth'
            | translate}}</a>
        </div>
      </div>
      <a class="hint" *ngIf="!isFreeInIdLevel" style="margin-bottom: 5px" target="_blank" href="https://platforma.ligazakon.net/buy-{{lang}}/">{{'access.hint'
        | translate}}</a>
    </div>
    <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 buttons-block" *ngIf="!isAnonymous">
      <div class="title">{{'access.titleBuyForm' | translate}}</div>
      <div class="btn-access-block">
        <div class="row" *ngIf="productId == 'semantrum_web'">
          <a class="access-btn" target="_blank" href="{{buyLink}}"><span class="btn-primary-text">{{'access.btnBuy' |
              translate}}</span></a>
        </div>
        <div class="row" *ngIf="productId == 'reporting'">
          <a class="access-btn" target="_blank" href="{{productBuyLink}}"><span class="btn-primary-text">{{'access.btnBuy'
              | translate}}</span></a>
        </div>
        <div class="row" *ngIf="productId != 'reporting' && productId != 'semantrum_web'">
          <a class="access-btn" target="_blank" href="https://platforma.ligazakon.net/buy-{{lang}}/"><span class="btn-primary-text">{{'access.btnBuy'
              | translate}}</span></a>
        </div>
        <div class="row" *ngIf="productId == 'reporting'">
          <a class="hint cp" (click)="testReporting(); close()">{{'access.btnTry' | translate}}</a>
        </div>
        <div class="row" *ngIf="productId == 'semantrum_web'">
          <a class="hint cp" target="_blank" href="{{testLink}}">{{'access.btnTry' | translate}}</a>
        </div>
        <div class="row" *ngIf="productId != 'reporting' && productId != 'semantrum_web'">
          <a class="hint cp" (click)="doPurchase('ipas_commercial',true); close()">{{'access.btnTry' | translate}}</a>
        </div>
      </div>
      <a class="hint" style="margin-bottom: 5px" href="https://platforma.ligazakon.net/buy-{{lang}}/" target="_blank">{{'access.hint'
        | translate}}</a>
    </div>
  </div>
  <div class="close" (click)="close()"><i class="fa fa-times" aria-hidden="true"></i></div>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}::ng-deep .cdk-overlay-container{z-index:1111}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane{max-width:95vw!important}::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{margin:0;padding:0;max-height:95vh;border-radius:0}@media (max-width:757px){::ng-deep .cdk-overlay-container ::ng-deep .cdk-overlay-pane ::ng-deep .mat-dialog-container{max-height:80vh}}::ng-deep .cdk-global-scrollblock{position:static!important;overflow:hidden}::ng-deep .cdk-global-scrollblock body{overflow:hidden}.access-btn{background-image:none;display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;padding:15px 24px;font-size:16px;line-height:1.42857143;border-radius:4px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;color:#fff;background-color:#00adfa;border:none;overflow:hidden;z-index:1;position:relative;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.15);box-shadow:0 2px 5px 0 rgba(0,0,0,.15);margin-right:10px}.access-btn:after{position:absolute;content:'';right:0;left:0;bottom:0;height:4px;background:#009ce9;transition:.15s;-webkit-transition:.15s;-o-transition:.15s;z-index:-1}.close{right:11px;top:7px;position:absolute;cursor:pointer}.modal-content{overflow:hidden}.container{width:auto;background:#f5fdff}.info-block{font-family:Geometria,Arial,sans-serif;background:#fff;padding:40px 20px 40px 40px;min-height:400px}.info-block .title{margin-left:30px;font-size:22px;font-weight:900;line-height:1.5em;color:#00b0ff}.info-block .text{padding:30px;line-height:1.4em}.info-block .button{float:left;display:block;position:relative;margin-right:30px}.info-block .button.lawmaking .box{background-image:url(/dist/ng2/src/assets/pl-header-assets/img/lawmaking.png);background-repeat:no-repeat;background-position:center center}.info-block .button.lawmaking .box .title{text-shadow:0 1px 5px rgba(41,58,85,.15),0 2px 15px rgba(66,165,245,.25);font-size:18px;font-weight:700;color:#fff}.info-block .button.advocatebase .box .title{font-size:18px;font-weight:700}.info-block .button .box{overflow:hidden;padding-top:15px;margin-bottom:12px;position:relative;text-align:center;text-decoration:none;width:120px;height:120px;-webkit-transition:.5s cubic-bezier(.73,.14,.4,1.58);transition:.5s cubic-bezier(.73,.14,.4,1.58);background:rgba(255,255,255,.9);border-radius:6px;-webkit-box-shadow:0 1px 5px 0 rgba(41,58,85,.15),0 2px 15px 0 rgba(66,165,245,.25);box-shadow:0 1px 5px 0 rgba(41,58,85,.15),0 2px 15px 0 rgba(66,165,245,.25);opacity:1;transform:translateY(0) translateZ(0);-webkit-transform:translateY(0) translateZ(0);-moz-transform:translateY(0) translateZ(0);-o-transform:translateY(0) translateZ(0);-ms-transform:translateY(0) translateZ(0);z-index:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (max-width:479px){.info-block{padding:40px 20px}.info-block .title{margin-left:0;width:100%;text-align:center;margin-bottom:8px}.info-block .button{float:unset;display:block;margin-right:0;text-align:center}.info-block .button .box{display:inline-block}}.info-block .button .box .type{font-size:12px;color:#fff;font-weight:700;text-transform:uppercase;background-color:#8c8c8c;border-radius:5px;margin-top:5px;line-height:1.45;padding:0 10px;display:inline-block}.info-block .button .box .title{margin:13px auto auto;text-transform:uppercase;font-size:10px;line-height:1.45;font-weight:700;color:#293a55;padding:0 10px}.info-block .button .box .module_ico{background-size:contain;width:36px;height:36px;margin:auto;background-repeat:no-repeat;background-position:center center}.info-block .button#instructions .box .title{margin-top:6px}@media (min-width:481px){.info-block .button .box{height:180px;width:180px;margin-bottom:12px;padding-top:26px}.info-block .button .box .type{font-size:13pt;line-height:20pt}.info-block .button .box .module_ico{width:60px;height:60px}.info-block .button .box .title{font-size:16px;font-weight:600;margin-top:14px;line-height:normal}.info-block .button#instructions .box .title{margin-top:6px}}@media (min-width:758px){.info-block .button .box{height:200px;width:200px;margin-bottom:24px;padding-top:35px}.info-block .button .box .type{font-size:16px}.info-block .button .box .title{margin-top:24px;font-size:16px;font-weight:600}.info-block .button#instructions .box .title{margin-top:10px}.modal-lg{width:732px}}.info-block .button.judicial_practice_for_acountant .type,.info-block .button.situationAccountant .type{background-color:#11b08d}.info-block .button.situationBusiness .type{background-color:#f9a825}.info-block .button.situationLawyer .type{background-color:#1e88e5}.info-block .button.cases_for_hr .type,.info-block .button.instructions .type{background-color:#e31b24}.info-block .about-module .tip{display:inline-block}.buttons-block{font-family:Geometria,Arial,sans-serif;padding:40px 50px 20px;position:relative}.buttons-block .pb40{padding-bottom:40px!important}.buttons-block .pb15{margin-bottom:15px!important}.buttons-block .pb10{margin-bottom:10px!important}.buttons-block .pb25{margin-bottom:25px!important}.buttons-block .cp{font-size:16px!important;cursor:pointer}.buttons-block .cp:hover{text-decoration:none}.buttons-block .sub-auth-title{font-size:12px;margin-bottom:0!important;margin-top:10px!important}.buttons-block .orange-button{color:#000}.buttons-block .btn-primary-text{font-weight:500}.buttons-block .title{font-size:22px;font-weight:400;padding:0 35px;text-align:center;margin-bottom:20px;line-height:1.5em;color:#25408f}.buttons-block .sub-title{text-align:center;margin-bottom:20px}.buttons-block .hint{display:block;color:#00b0ff;margin-bottom:45px;font-size:13px;text-align:center}.buttons-block .hint:hover{text-decoration:none}.buttons-block .btn-access-block{text-align:center;margin-top:10px;margin-bottom:74px}.buttons-block .btn-access-block .btn{padding-left:30px;padding-right:30px;margin:5px}.buttons-block .btn-access-block .btn-default{-webkit-box-shadow:0 1px 5px 0 rgba(41,58,85,.15),0 2px 15px 0 rgba(66,165,245,.25);box-shadow:0 1px 5px 0 rgba(41,58,85,.15),0 2px 15px 0 rgba(66,165,245,.25);border:none}@media (min-width:1002px){.modal-lg{width:976px}}@media (min-width:1490px){.modal-lg{width:1464px}}`]
})

export class AccessMessageComponent {
  public doc: any;
  public aliasInfo;
  public buttonsInfo = buttonsInfoConfig;
  public lang;
  public buyLink;
  public testLink;
  public productId;
  public isProductText;
  public productBuyLink;
  public isAnonymous = true;
  public productCode;
  public isFreeInIdLevel = false;
  public title;
  public docHelpId;
  public isShowing = false;

  private config = {};

  public onlyBuyAliases = [
    'ukraine_goverment_access',
    'contracts&templates_access',
    'bankrupcy_access',
    'directories_access',
    'cases_for_business_access',
    'taxation_knowlege_base_access',
    'advice_for_accountant_access',
    'forms&blanks_access',
    'calculator_zp_access',
    'calculator_vc_access',
    'cases_for_accountant_access',
    'accounting_entries_access',
    'judicial_practice_for_acountant_access',
    'cases_for_hr_access',
    'instructions_access',
    'glossary_access',
    'calculator_ff_access',
    'draft_laws_access',
    'cases_for_lawyer_access',
    'judicial_practice_access',
    'commented_codexes_access',
    'european_legislation_access',
    'business_safety_ceo_access',
    'precedents_access',
    'industry_access',
    'accountant_and_law',
    'business_schema'
  ];

  constructor(
    private lzProductConfig: LzProductConfig,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef < AccessMessageComponent > ,
    private purchase: LzPurchaseService,
    private customRequestService: CustomRequestService,
    private user: LzUserServiceV2
  ) {
    this.config = this.lzProductConfig.getProductSettings();

    let body = document.querySelector('body');

    this.buyLink = this.data.buyLink || '';
    this.testLink = this.data.testLink || '';
    this.productId = this.data.productId || '';
    this.isProductText = this.data.isProductText || '';
    this.productBuyLink = this.data.prodLending || '';

    this.user.check((data) => {
      this.isAnonymous = data.anonymous;
    });

    this.productCode = this.data.alias;
    this.title = this.data.alias;

    try {
      this.aliasInfo = aliasesConfig[this.data.alias];
      this.docHelpId = this.aliasInfo && this.aliasInfo.docId ? this.aliasInfo.docId : 'HP000001';
    } catch (error) {
      this.docHelpId = 'HP000001';
    } finally {}

    this.getTextAboutModule(this.docHelpId).subscribe((msg) => {
      this.doc = msg;
      this.isShowing = true;
    });

    this.findConfigurations(this.data.alias, 'ipas_demo').subscribe((data) => {
      if (data[0]) {
        if (data[0].alias == 'ipas_demo') {
          this.isFreeInIdLevel = true;
        }
        if (this.onlyBuyAliases.indexOf(this.data.alias) != -1) {
          this.isFreeInIdLevel = false;
        }
      }
    });

    if (this.data.isReg) {
      this.isFreeInIdLevel = true;
    }
  }

  close() {
    this.dialogRef.close();
  };

  doPurchase(code, isTrial) {
    let newCode = '';
    switch (code) {
      case 'b_mini':
        newCode = 'ipas_commercial';
        break;
      case 'uz_web':
        newCode = 'uz_web';
        break;
      case 'bz_web':
        newCode = 'bz_web';
        break;
      case 'fz_web':
        newCode = 'fz_web';
        break;
      case 'verdictum_web':
        newCode = 'verdictum_web';
        break;
      case 'ib':
        newCode = 'interbuh_standart';
        break;
      case 'expert':
        newCode = 'ipas_commercial';
        break;
      case 'smsmayak':
        newCode = 'ipas_commercial';
        break;
      case 'semantrum_web':
        newCode = 'ipas_commercial';
        break;
      case 'comfort':
        newCode = 'ipas_commercial';
        break;
      case 'ips_reporting':
        newCode = 'ipas_commercial';
        break;
      case 'grand_excess':
        newCode = 'grand_excess';
        break;
      case 'contractor':
        newCode = 'contragent_premium';
        break;
      case 'reporting_holding_15':
        newCode = 'reporting_holding_15';
        break;
      case 'interbuh_standart':
        newCode = 'interbuh_standart';
        break;
      case 'consultation':
        newCode = 'ipas_commercial';
        break;
      case 'product_lighthouse':
        newCode = 'ipas_commercial';
        break;
    }

    if (this.data.realAlias) {
      newCode = 'grand_excess';
    }

    this.purchase.doPurchaseNew(newCode, isTrial);
  };

  getTextAboutModule(id) {
    return this.customRequestService.getRequest('lzviewservice/document/' + id);
  };

  findConfigurations(alias, checkConfiguration) {
    return this.customRequestService.getRequest('lzservice/userData/findConfigurations', {
      alias: alias,
      checkConfiguration: checkConfiguration
    });
  };

  testReporting() {
    window.open('https://platforma.ligazakon.net/test-report-ua/');
  };

  public getLink = (type, alias ? , referer ? ) => {
    let prodAlias = (alias) ? alias : '',
      prodReferer = (referer) ? referer : window.location.href;
  }

  public goReg = () => {
    window.location.href = this.config['ipas_location'] + '/?type=reg&alias=' + this.config['order_code'] + '&referer=' + window.location.href;
  }

  public goAuth = () => {
    window.location.href = this.config['ipas_location'] + '/?type=auth&alias=' + this.config['order_code'] + '&referer=' + window.location.href;
  }

}
